<template>
  <div v-if="data.length">
    <download-excel
      class="excel"
      :title="hyeader"
      :data="json_data"
      :fields="json_fields"
      worksheet="Opportunités"
      name="exportOpp.xls">
      <div class="icon-excel pointer has-text-default">
        <b-icon icon="file-excel"
          type="is-white" custom-class="icon-position"></b-icon>
      <p class="p_size10 has-text-default mt-5px">
        Exporter les faces</p>
      </div>
    </download-excel>
  </div>
</template>

<script>

export default {
  name: 'exportExcel',
  props: ['data', 'nom', 'periode', 'showDimension'],
  data() {
    return {
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8',
          },
        ],
      ],
    };
  },
  computed: {
    hyeader() {
      return [
        'Nom du réseau : ' + this.nom,
        'Période : ' + this.periode,
        'Nombre de faces : ' + this.data.length,
        '',
        'Liste des faces :',
      ];
    },
    json_fields() {
      if (this.showDimension) {
        return {
          'Code face': 'facCode',
          Format: 'format',
          'Hauteur (cm)': 'longueur',
          'Largeur (cm)': 'largeur',
          Matériel: 'materiel',
          Adresse: 'adresse',
          'Code postal': 'codePostal',
          Ville: 'ville',
        };
      }
      return {
        'Code face': 'facCode',
        Format: 'format',
        Matériel: 'materiel',
        Adresse: 'adresse',
        'Code postal': 'codePostal',
        Ville: 'ville',
      };
    },
    json_data() {
      const tab = [];
      const dat = this.data;
      if (this.showDimension) {
        dat.forEach(d => {
          tab.push({
            facCode: d.facCode ? d.facCode : d.code,
            format: d.format,
            longueur: d.materielLongueur,
            largeur: d.materielLargeur,
            materiel: d.materiel,
            adresse: d.adresseCommercialeLibelle1,
            codePostal: d.codePostal,
            ville: d.ville,
          });
        });
      } else {
        dat.forEach(d => {
          tab.push({
            facCode: d.facCode ? d.facCode : d.code,
            format: d.format,
            materiel: d.materiel,
            adresse: d.adresseCommercialeLibelle1,
            codePostal: d.codePostal,
            ville: d.ville,
          });
        });
      }
      return tab;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/exportExcel.vue